import React from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankLength = ({ dataField, setDataField, error }) => {
  const {
    iotOrderDetailsSection: { tankLength },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();
  const fieldHasError = error && !dataField.valueTankLength;

  return (
    <TextInput
      label={tankLength}
      type="text"
      value={dataField.valueTankLength}
      validation={fieldHasError ? 'error' : undefined}
      feedback={fieldHasError ? fieldRequiredMessage : undefined}
      onChange={(value) => {
        const regex = new RegExp('^[1-9]');
        const fieldValue = regex.test(+value) ? value : '';
        setDataField({ ...dataField, valueTankLength: fieldValue });
      }}
    />
  );
};

TankLength.propTypes = {
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankLength;
